import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { clx, currencyFormatter } from 'Utils';
import { Card } from 'Elements';
import styles from 'partials/card/subscription-card.module.scss';
import { FC } from 'react';
import { CreditDetails } from 'src/types/Transactions';
import { SkeletonCommissionLevel } from '../skeleton/SkeletonCommissionLevel';

interface Props {
	credit: CreditDetails | undefined;
	isLoading: boolean;
}

export const CommissionLevel: FC<Props> = ({ credit, isLoading }) => {
	const { t } = useTranslation();

	return isLoading ? (
		<SkeletonCommissionLevel />
	) : (
		<Col>
			<Card>
				<h6 className={clx(styles.row, 'text-gray-3 fs-6 fw-400')}>
					<span className={styles.rowLabel}>
						{t('label.commission-level')}
					</span>
				</h6>
				<Row>
					<Col sm={12}>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								{t('label.title')}
							</span>
							<span>
								{credit?.commissionLevelInfo?.title ?? '---'}
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								{t('label.min-active-abo')}
							</span>
							<span>
								{credit?.commissionLevelInfo?.minActiveAbo}
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								{t('label.max-active-abo')}
							</span>
							<span>
								{credit?.commissionLevelInfo?.maxActiveAbo}
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								{t('label.commission-percent')}
							</span>
							<span>
								{`${credit?.commissionLevelInfo?.commissionPercent}%`}
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								{t('label.commission-cost')}
							</span>
							<span>
								{currencyFormatter(
									credit?.commissionLevelInfo
										?.commissionCost ?? 0
								)}
							</span>
						</div>
					</Col>
				</Row>
			</Card>
		</Col>
	);
};
